import { useEffect } from "react";

/**
 * Tiny analytics helper. Writes named events + payloads to window.dataLayer
 * so a future GA/GTM/Segment install can consume them without code changes.
 * Silent no-op if dataLayer isn't defined. Never fabricates results.
 */
export function track(event, payload = {}) {
  try {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...payload, ts: Date.now() });
  } catch (_) { /* silent */ }
}

/** Fire an event once when a component mounts. */
export function useTrackPageView(event, payload = {}) {
  useEffect(() => { track(event, payload); /* eslint-disable-next-line */ }, []);
}
